import React, { Component } from 'react';
import PropTypes from 'prop-types';
import update from 'react-addons-update';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Grid } from 'semantic-ui-react';
import queryString from 'query-string';
import storage from 'helpers/storage';

import { Management, Commons } from 'components';
import * as cpAction from 'actions/company';
import * as cmAction from 'actions/commons';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import { safeHistoryPush } from 'helpers/pathValidator';

const propTypes = {};

const defaultProps = {};

class StaffManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagerow: null,
      param: {
        keyword: null,
        state: null,
        auth: null,
        orgCode: null,
        groupid: null,
        viewType: 'all',
        dormantTargetFilter: false
      },
      staffCheckedData: [],
      isLoadingBar: false,
      tabType: 'division',
      userTotal: 0,
      userCnt: 0,
      changeInfoParams: null
    };
  }

  async componentDidMount() {
    cm.mainTitle('사용자 관리');
    const { param, userTotal } = this.state;
    const { location } = this.context.router.route;
    const { dormant } = queryString.parse(location.search);
    if (dormant) {
      const dormantTargetFilter = dormant === 'true';
      const parma2 = { dormantTargetFilter };
      await this.staffSel({ ...param, ...parma2 });
      // 조회 응답이 도착하기 전에 화면을 벗어났으면 상태를 갱신하지 않는다.
      if (this.unmounted) return;
      this.setState({
        param: update(this.state.param, {
          dormantTargetFilter: { $set: dormantTargetFilter }
        })
      });
    } else {
      await this.staffSel(param);
    }

    // 이후 상태 갱신·추가 조회도 언마운트 이후에는 수행하지 않는다.
    if (this.unmounted) return;

    const { divisionUserCnt } = this.props;
    if (divisionUserCnt && userTotal === 0) {
      let cnt = 0;
      divisionUserCnt.forEach((item) => {
        cnt += item.userCnt;
      });
      if (cnt > userTotal) {
        await this.setState({
          userTotal: cnt
        });
      }
    }
    this.sikdaeGroupSel(); // 식대그룹 조회
    this.positionSel(); // 직위 조회
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { text } = this.props;
    const { text: nText } = nextProps;

    return !(text !== nText);
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  isLoadingBarChange = async (isShow) => {
    await this.setState({ isLoadingBar: isShow });
  };

  staffDivisionSel = async () => {
    const { cmAPI } = this.props;
    const params = { viewType: 'all' };

    try {
      await cmAPI.staffDivisionSel(params);

      const { staffDivisionList } = this.props;

      if (staffDivisionList && staffDivisionList.data) {
        const { division, depth } = staffDivisionList.data;
        const navi = await cm.divisionNavigation(division);

        cm.staffDivisionNavigation(depth, navi);
      }
    } catch (e) {
      const { response } = e;

      if (response) {
        console.log('###### staffDivision call error : ', e);
      }
    }
  };

  orgCodeChange = async (orgCode, depth, isHaveChild) => {
    const newParam = update(this.state.param, { orgCode: { $set: orgCode } });
    this.setState({
      param: newParam
    });
    if (depth > 1 && !isHaveChild) {
      this.staffSel(newParam);
    }
  };

  // 부서 수정
  divisionMod = async (params) => {
    try {
      const { cpAPI } = this.props;
      const { param } = this.state;

      if (!params.id) {
        params.id = param.orgCode;
      }

      await cpAPI.divisionMod(params);
      this.staffDivisionSel();
      // return true;
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
    }
  };

  // 부서 삭제
  divisionDel = async () => {
    try {
      const { cpAPI } = this.props;
      const { param } = this.state;
      const params = {
        id: param.orgCode
      };

      await cpAPI.divisionDel(params);
      this.staffDivisionSel();
      // return true;
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### divisionSortDel error : ', e);
    } finally {
    }
  };

  // 부서 추가
  divisionAdd = async (params) => {
    try {
      const { cpAPI } = this.props;

      await cpAPI.divisionAdd(params);
      this.staffDivisionSel();
      // return true;
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### divisionAdd error : ', e);
    } finally {
    }
  };

  // 오름차순
  divisionAscending = async (params) => {
    try {
      const { cpAPI } = this.props;
      const { param } = this.state;

      if (!params.id) {
        params.id = param.orgCode;
      }

      await cpAPI.divisionMod(params);
      this.staffDivisionSel();
      // return true;
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### divisionAscending error : ', e);
    } finally {
    }
  };

  // 식대그룹 조회
  sikdaeGroupSel = async () => {
    // this.isLoadingBarChange(true);
    const { param } = this.state;
    const { cmAPI } = this.props;
    const params = { viewType: param.viewType };

    try {
      await cmAPI.sikdaeGroupSel(params);
    } catch (e) {
      const { response } = e;
      if (response && response.data) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### sikdaeGroupSel Error : ', e);
    } finally {
      // this.isLoadingBarChange(false);
    }
  };

  // 직위 조회
  positionSel = async () => {
    // this.isLoadingBarChange(true);
    const { cpAPI } = this.props;

    try {
      await cpAPI.positionSel();
    } catch (e) {
      console.log('###### positionSel Error : ', e);
    } finally {
      // this.isLoadingBarChange(false);
    }
  };

  // 직위 등록
  positionAdd = async () => {
    try {
      const dom = document.getElementById('position-name');
      const { cpAPI } = this.props;

      const params = {
        name: dom.value
      };

      if (params.name.length > 10) {
        toastr('top-right', 'warning', '10자 이하로 입력해주세요.');
        return;
      }
      await cpAPI.positionAdd(params);
      this.positionSel();
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### PositionAdd error : ', e);
    } finally {
    }
  };

  // 직위 수정
  positionMod = async (id) => {
    try {
      const dom = document.getElementById(id);
      const { cpAPI } = this.props;
      const params = {
        name: dom.value,
        id
      };

      if (params.name.length > 10) {
        toastr('top-right', 'warning', '10자 이하로 입력해주세요.');
        return;
      }
      await cpAPI.positionMod(params);
      this.positionSel();
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### positionMod error : ', e);
    } finally {
    }
  };

  // 직위 삭제
  positionDel = async (params) => {
    try {
      const { cpAPI } = this.props;
      await cpAPI.positionDel(params);

      this.positionSel();
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### positionDel error : ', e);
    } finally {
    }
  };

  // 사용자 조회
  staffSel = async (params) => {
    this.isLoadingBarChange(true);
    const { cmAPI } = this.props;

    try {
      params.type = 'all';
      await cmAPI.staffSel(params);
      // 조회 응답이 도착하기 전에 화면을 벗어났으면 이후 상태 갱신을 하지 않는다.
      if (this.unmounted) return;
      const { staffList } = this.props;
      if (staffList && staffList.data) {
        const { paging } = staffList.data;

        await this.setState({
          userCnt: paging.totalcount
        });
      }

      this.isLoadingBarChange(false);
    } catch (e) {
      const { response } = e;
      if (!this.unmounted) this.isLoadingBarChange(false);

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### staffSel error : ', e);
    } finally {
    }
  };

  // 사용자목록 엑셀관리 이동
  moveStaffExcel = () => {
    this.context.router.history.push('/main/StaffManagementByExcel');
  };

  // 부서목록 엑셀관리 이동
  moveDivisionExcel = () => {
    this.context.router.history.push('/main/divisionManagementByExcel');
  };

  // 부서별 사용자 카운트
  divisionUserCntSel = async (params) => {
    // this.isLoadingBarChange(true);
    const { cpAPI } = this.props;
    const { userTotal } = this.state;
    try {
      await cpAPI.divisionUserCntSel(params);
      // 조회 응답 전에 화면을 벗어났으면 상태를 갱신하지 않는다.
      if (this.unmounted) return;
      const { divisionUserCnt } = this.props;
      if (userTotal === 0) {
        let cnt = 0;
        divisionUserCnt.forEach((item) => {
          cnt += item.userCnt;
        });
        if (cnt > userTotal) {
          await this.setState({
            userTotal: cnt
          });
        }
      }
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### divisionUserCntSel error : ', e);
    } finally {
      // this.isLoadingBarChange(false);
    }
  };

  // 부서별 사용자 조회
  divisionStaffSel = async (_orgCode) => {
    const { param } = this.state;
    const { auth, status } = this.props;
    const orgCode = _orgCode;
    const params = {
      keyword: param.keyword,
      orgCode,
      viewType: param.viewType,
      status: status ? status.value : null,
      grade: auth ? auth.value : null,
      dormantTargetFilter: param.dormantTargetFilter
    };
    await this.staffSel(params);
    // 조회 응답 전에 화면을 벗어났으면 상태를 갱신하지 않는다.
    if (this.unmounted) return;
    this.setState({
      param: update(this.state.param, { orgCode: { $set: orgCode } }),
      staffCheckedData: []
      // , isChecked : false
    });
    $('.checkbox.pure input').prop('checked', false);

    this.isLoadingBarChange(false);
  };

  // 식대그룹별 사용자 조회
  groupStaffList = async (group) => {
    const { param } = this.state;
    const { auth, status } = this.props;

    const gIdx = group ? group.idx : null;
    const params = {
      keyword: param.keyword,
      groupid: gIdx,
      viewType: param.viewType,
      status: status ? status.value : null,
      grade: auth ? auth.value : null,
      dormantTargetFilter: param.dormantTargetFilter
    };
    this.staffSel(params);

    this.setState({
      param: update(this.state.param, {
        groupid: { $set: gIdx },
        orgCode: { $set: null }
      }),
      staffCheckedData: []
    });
  };

  handleSubmit = (dormantCheck) => {
    const { auth, text, status } = this.props;
    const { param } = this.state;
    const params = {
      orgCode: param.orgCode,
      groupid: param.groupid,
      grade: auth ? auth.value : null,
      status: status ? status.value : null,
      keyword: text ? text.value : null,
      viewType: param.viewType,
      dormantTargetFilter: typeof dormantCheck === 'boolean' ? dormantCheck : param.dormantTargetFilter
    };
    this.setState({
      param: update(this.state.param, {
        keyword: { $set: params.keyword },
        grade: { $set: params.grade },
        status: { $set: params.status }
      })
    });

    this.staffSel(params);
  };

  // 검색
  handleEntSubmit = async (e) => {
    const { auth, status } = this.props;
    const { param } = this.state;
    if (e.key === 'Enter') {
      const keyword = e.target.value;
      const params = {
        keyword,
        orgCode: param.orgCode,
        groupid: param.groupid,
        grade: auth ? auth.value : null,
        status: status ? status.value : null,
        viewType: param.viewType,
        dormantTargetFilter: param.dormantTargetFilter
      };
      this.setState({
        param: update(this.state.param, {
          keyword: { $set: keyword },
          grade: { $set: params.grade },
          status: { $set: params.status }
        })
      });

      this.staffSel(params);
    }
  };

  // 사용자 체크박스 선택 on/off
  staffChecked = async (e, data, type) => {
    const { staffList } = this.props;
    const events = e.target;
    const targetChecked = e.target.checked;

    // 전체 선택 on/off
    if (type === 'all') {
      this.isLoadingBarChange(true);
      const staffData = staffList ? staffList.data.user : null;
      // 전체 on/off 된 데이터 반환
      const staffCheckedData = cm.staffCheckedData(e, staffData, targetChecked, 'all');

      await this.setState({
        staffCheckedData
      });

      this.isLoadingBarChange(false);

      $('.allCheckbox').prop('checked', targetChecked);
      $('.staff-checkbox').prop('checked', targetChecked);
    }

    if (type !== 'all') {
      this.setState((prevState) => ({
        staffCheckedData: cm.staffCheckedData(events, prevState.staffCheckedData, targetChecked, 'each')
      }));
    }
  };

  // 사용자 부서, 식대그룹, 퇴사 bulk 완료
  bulkCompletionBtn = (type, reserveDate) => {
    const { staffCheckedData } = this.state;
    const id = [];
    let value = null;

    // 사용자 id
    staffCheckedData.forEach((data) => {
      id.push(data.id);
    });

    // 부서 이동
    if (type === 'division') {
      const { depth } = this.props;

      if (depth.value) {
        value = depth.value;
      } else {
        toastr('top-right', 'error', '부서를 선택해주세요.');
        return;
      }

      // 식대 그룹 이동
    } else if (type === 'group') {
      const { groupIdx } = this.props;
      if (!groupIdx.value) {
        toastr('top-right', 'error', '식대그룹을 선택해주세요.');
        return;
      }
      value = groupIdx.value;

      // 계정 탈퇴
    } else if (type === 'withdraw') {
      value = -5;

      // 계정 일시정지
    } else if (type === 'pause') {
      value = -1;
      // 계정 일시정지해제
    } else if (type === 'pauseCancel') {
      value = 1;
    }

    const params = {
      type: {
        key: type,
        value
      },
      user: {
        id
      },
      reserveDate
    };
    this.staffBulkMod(params);
  };

  staffBulkMod = async (params) => {
    try {
      await this.setState({
        isLoadingBar: true
      });

      const { cpAPI } = this.props;
      await cpAPI.staffBulkMod(params);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (e) {
      const { response } = e;

      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### staffBulkMod error : ', e);
    } finally {
    }
  };

  movePage = (url) => {
    safeHistoryPush(this.context.router.history, url);
  };

  // 탭 이동
  tabMove = async (type) => {
    await this.setState({
      tabType: type
    });

    this.groupStaffList(null);
  };

  // 정보 변경 내역 조회
  changeInfoSel = async (params) => {
    const { cpAPI } = this.props;
    this.setState({ changeInfoParams: params });
    try {
      await cpAPI.changeInfoSel(params);
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### changeInfoSel error : ', e);
    }
  };

  // 정보 변경 내역 예약 취소
  cancelReserve = async (idx) => {
    const { cpAPI } = this.props;
    const { changeInfoParams } = this.state;
    try {
      await cpAPI.cancelReserveDel(idx);
      if (changeInfoParams) {
        this.changeInfoSel(changeInfoParams);
      }
    } catch (e) {
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }
      console.log('###### changeInfoSel error : ', e);
    }
  };

  // 휴면사용자 조회 조건 체크
  handleDomantCheck = () => {
    const {
      param: { dormantTargetFilter }
    } = this.state;
    const toggle = !dormantTargetFilter;

    this.handleSubmit(toggle);
    this.setState({
      param: update(this.state.param, {
        dormantTargetFilter: { $set: toggle }
      })
    });
  };

  render() {
    const { location } = this.props;
    const { param, staffCheckedData, isLoadingBar, tabType, userTotal, userCnt } = this.state;
    const leftArea = {
      fn: {
        groupStaffList: this.groupStaffList,
        divisionStaffSel: this.divisionStaffSel,
        divisionMod: this.divisionMod,
        divisionDel: this.divisionDel,
        divisionAdd: this.divisionAdd,
        divisionAscending: this.divisionAscending,
        divisionUserCntSel: this.divisionUserCntSel,
        tabMove: this.tabMove,
        isLoadingBarChange: this.isLoadingBarChange,
        orgCodeChange: this.orgCodeChange
      },
      data: {
        param,
        tabType,
        userTotal
      }
    };

    const rightArea = {
      fn: {
        staffSel: this.staffSel,
        handleEntSubmit: this.handleEntSubmit,
        staffChecked: this.staffChecked,
        isLoadingBarChange: this.isLoadingBarChange,
        handleSubmit: this.handleSubmit,
        handleDomantCheck: this.handleDomantCheck
      },
      data: {
        param,
        tabType,
        staffCheckedData,
        userCnt
        // , isLoadingBar: isLoadingBar
      }
    };

    const bottomBtnArea = {
      data: {
        staffCheckedData
      },
      fn: {
        movePage: this.movePage,
        positionDel: this.positionDel,
        positionAdd: this.positionAdd,
        positionMod: this.positionMod,
        bulkCompletionBtn: this.bulkCompletionBtn,
        changeInfoSel: this.changeInfoSel,
        cancelReserve: this.cancelReserve
      }
    };

    return (
      <main className="sm">
        {isLoadingBar ? <Commons.LoadingBar /> : null}
        <div className="top-btn button">
          <Button.Group>
            <Button
              inverted
              color="black"
              className="staff-add-btn"
              onClick={() => this.movePage('/main/staffInfo/join/new')}
            >
              사용자 추가
            </Button>
            <Button inverted color="green" onClick={this.moveStaffExcel}>
              사용자 엑셀파일로 관리
            </Button>
            <Button inverted color="green" className="division-excel-btn" onClick={this.moveDivisionExcel}>
              부서 엑셀 일괄 등록
            </Button>
          </Button.Group>
        </div>
        <div className="info-box">
          <Grid>
            <Grid.Column className="left-area">
              <Management.LeftArea fn={leftArea.fn} data={leftArea.data} />
            </Grid.Column>
            <Grid.Column className="right-area">
              <Management.RightArea staffCheckedDatadd={staffCheckedData} fn={rightArea.fn} data={rightArea.data} />
            </Grid.Column>
          </Grid>
        </div>
        <div className="botton-btn">
          <Management.BottomBtnArea data={bottomBtnArea.data} fn={bottomBtnArea.fn} />
        </div>
      </main>
    );
  }
}

StaffManagement.propTypes = propTypes;
StaffManagement.defaultProps = defaultProps;

StaffManagement.contextTypes = {
  router: PropTypes.object.isRequired
};

StaffManagement = connect(
  (state) => ({
    staffDivisionList: state.commons.staffDivision,
    staffList: state.commons.staff,
    depth: state.commons.depth,
    groupIdx: state.commons.group,
    divisionUserCnt: state.company.divisionUserCnt, // 부서별 사용자 수(카운트)
    auth: state.commons.auth,
    text: state.commons.text,
    status: state.commons.status
  }),
  (dispatch) => ({
    cpAPI: bindActionCreators(
      {
        positionSel: cpAction.PositionSel,
        positionAdd: cpAction.PositionAdd,
        positionMod: cpAction.PositionMod,
        positionDel: cpAction.PositionDel,
        staffBulkMod: cpAction.StaffBulkMod,
        divisionMod: cpAction.DivisionSortMod,
        divisionDel: cpAction.DivisionDel,
        divisionAdd: cpAction.DivisionAdd,
        divisionUserCntSel: cpAction.DivisionUserCnt,
        changeInfoSel: cpAction.ChangeInfoSel,
        cancelReserveDel: cpAction.CancelReserve
      },
      dispatch
    ),

    cmAPI: bindActionCreators(
      {
        sikdaeGroupSel: cmAction.SikdaeGroupList,
        staffSel: cmAction.StaffSel,
        staffDivisionSel: cmAction.StaffDivisionList
      },
      dispatch
    )
  })
)(StaffManagement);

export default StaffManagement;
